export default __webpack_public_path__ + "static/media/line-2-left.ea5afebf.svg";